<template>

    <template v-if="(typeof $route.params.id === 'undefined')">
        
        <!--################################################# ESCOLHER QUESTIONÁRIO #########################################################################-->
        <v-container fluid>
            <v-data-table v-model:sort-by="sortByData" class="table elevation-2" hover
            items-per-page-text="Itens por página" page-text="{0}-{1} de {2}" 
            :headers="headersQuestions" :items="listQuestions" :loading="loadingQuestions"
            @click:row="rowClick">
                <template v-slot:no-data>
                    <v-alert class="my-4" :value="true">
                        <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                    </v-alert>
                </template>
                <template v-slot:item.datetime="{ item }">{{ formatDate(item.columns.datetime) }}</template>
            </v-data-table>
        </v-container>
        <!--#################################################################################################################################################-->

    </template>

    <template v-else-if="(typeof $route.params.id !== 'undefined')">

        <!--################################################# CRIAR PROVA ###################################################################################-->
        <template v-if="$route.params.pPage === 'Aplicar'">
            <v-card-text>
                <v-alert v-model="alert" class="my-3" closable :text="alertText" :type="alertType" />
                <v-form v-model="isFormValid" @submit.prevent="onSubmit">
                    <v-text-field v-model="nota_maxima.value.value" color="primary" label="Nota Máxima" :error-messages="nota_maxima.errorMessage.value" />
                    <v-text-field v-model="nota_individual.value.value" color="primary" label="Nota Individual (%)" :error-messages="nota_individual.errorMessage.value" />
                    <v-text-field v-model="nota_equipe.value.value" color="primary" label="Nota Equipe (%)" :error-messages="nota_equipe.errorMessage.value" />
                    <v-combobox
                        v-model="disciplina.value.value"
                        color="primary"
                        density="comfortable"
                        label="Disciplina"
                        prepend-inner-icon="mdi-book-open-page-variant"
                        variant="outlined"
                        :error-messages="disciplina.errorMessage.value"
                        :items="disciplinas"
                        :loading="loadingDisciplinas"
                    />
                    <v-select
                        v-model="selected_turmas.value.value"
                        chips
                        closable-chips
                        color="primary"
                        density="comfortable"
                        item-title="label"
                        item-value="codigo"
                        label="Turmas"
                        multiple
                        prepend-inner-icon="mdi-account-group"
                        variant="outlined"
                        :error-messages="selected_turmas.errorMessage.value"
                        :items="turmas"
                        :loading="loadingTurmas"
                    />
                    <v-checkbox v-model="opt_mix_answers.value.value" color="primary" hide-details label="Embaralhar as respostas" value=true />
                    <v-btn :disabled="!isFormValid" class="bg-primary me-4" type="submit" :loading="loadingStartTest">Iniciar</v-btn>
                    <v-btn class="bg-primary" @click="handleReset()">Limpar</v-btn>
                </v-form>
            </v-card-text>
        </template>
        <!--#################################################################################################################################################-->

        <!--################################################## APLICAÇÂO PROVA ##############################################################################-->
        <template v-else-if="$route.params.pPage === 'Prova'">
            <v-container fluid>
                <v-row>
                    <v-col v-for="card in liveStatusCards" :key="`${statusProva}-${card.title}`" cols="12" sm="6" md="3">
                        <v-card class="status-card mx-auto" min-height="135" :prepend-icon="card.icon" :color="card.tone" variant="tonal">
                            <template v-slot:title>{{ card.title }}</template>
                            <v-card-text>
                                <div class="status-card__value">{{ card.value }}</div>
                                <div class="status-card__subtitle">{{ card.subtitle }}</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card class="mx-auto phase-summary-card" :class="phaseMeta.panelClass" min-height="100" prepend-icon="mdi-information">
                            <template v-slot:title>Informações</template>
                            <v-card-text>
                                <p><strong>Atividade Avaliativa:</strong> {{ provaNome }}</p>
                                <p><strong>Senha:</strong> {{ provaSenha }}</p>
                                <p><strong>Quantidade de questões:</strong> {{ nQuestoes }}</p>
                                <p><strong>Status:</strong> {{ statusNomeProva }}</p>
                                <v-chip class="mt-3 mr-2" :color="phaseMeta.color" variant="flat" :prepend-icon="phaseMeta.icon">
                                    {{ phaseMeta.label }}
                                </v-chip>
                                <v-chip class="mt-3" :color="syncStatusMeta.color" variant="tonal" :prepend-icon="syncStatusMeta.icon">
                                    {{ syncStatusMeta.text }}
                                </v-chip>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn class="bg-primary" variant="flat" :loading="loadingChangeTestStatus" @click="changeTestStatus(provaId, (parseInt(statusProva) + 1), 0)">{{ btnName }}</v-btn>
                                <v-btn color="red" variant="flat" @click="cancelTestAsk(provaId, 6)">Cancelar Atividade Avaliativa</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <div class="activity-summary-bar">
                            <div class="activity-summary-grid">
                                <div v-for="item in activitySummaryItems" :key="item.label" class="activity-summary-item">
                                    <div class="activity-summary-item__label">{{ item.label }}</div>
                                    <div class="activity-summary-item__value">{{ item.value }}</div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>

                        <!--############################################### SALA DE AULA ####################################################################-->
                        <v-card v-if="statusProva === '1'" class="mx-auto" :class="phaseMeta.panelClass" min-height="200" prepend-icon="mdi-chair-school">
                            <template v-slot:title>Sala de Aula</template>
                            <v-card-text>
                                <v-data-table :key="classroomTableKey" v-model:sort-by="sortByName" v-model:items-per-page="classroomItemsPerPage" class="table elevation-2" hover
                                items-per-page-text="Itens por página" page-text="{0}-{1} de {2}"
                                :headers="headersClassroom" :items="listStudents" :items-length="classroomStudentsCount" :loading="loadingStudents">
                                    <template v-slot:no-data>
                                        <v-alert class="my-4" :value="true">
                                            <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                                        </v-alert>
                                    </template>
                                    <template v-slot:item.id="{ item }">
                                        <v-icon icon="mdi-delete" class="ma-2 pa-2" color="error" size="small" @click="deleteStudent(provaId, item.columns.id)" />
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                        <!--##################################################################################################################################-->

                        <!--####################################### RESPOSTAS PROVA INDIVIDUAL ###############################################################-->
                        <v-card v-else-if="statusProva === '2'" class="mx-auto" :class="phaseMeta.panelClass" min-height="200" prepend-icon="mdi-note-text">
                            <template v-slot:title>Respostas da Atividade Avaliativa Individual</template>
                            <v-card-text>
                                <v-data-table :key="individualTableKey" v-model:sort-by="sortByName" v-model:items-per-page="individualItemsPerPage" class="table elevation-2"
                                items-per-page-text="Itens por página" page-text="{0}-{1} de {2}"
                                :headers="headersStudentsTest" :items="listStudentsTest" :items-length="individualStudentsCount" :loading="loadingStudentsTest">
                                    <template v-slot:no-data>
                                        <v-alert class="my-4" :value="true">
                                            <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                                        </v-alert>
                                    </template>
                                    <template v-for="(, i) in nQuestoes" :key="i" v-slot:[`item.${gamb(i)}`]="{ item }">
                                        <v-icon v-if="item.columns[gamb(i)] === 'certo'" color="success" icon="mdi-check-circle" size="x-large" />
                                        <v-icon v-else-if="item.columns[gamb(i)] === 'quase'" color="warning" icon="mdi-alert-circle" size="x-large" />
                                        <v-icon v-else-if="item.columns[gamb(i)] === 'errado'" color="error" icon="mdi-alpha-x-circle" size="x-large" />
                                    </template>
                                </v-data-table>
                            </v-card-text>
                            <v-card-actions class="ml-2">
                                Legenda:
                                <v-icon class="ml-2 mr-1" color="success" icon="mdi-check-circle" size="x-large" /> Resposta Correta
                                <v-icon class="ml-4 mr-1" color="warning" icon="mdi-alert-circle" size="x-large" /> Resposta Parcialmente Correta
                                <v-icon class="ml-4 mr-1" color="error" icon="mdi-alpha-x-circle" size="x-large" /> Resposta Errada
                            </v-card-actions>
                        </v-card>
                        <!--#################################################################################################################################-->    

                        <!--########################################### GRUPOS ##############################################################################-->
                        <v-card v-if="statusProva === '3'" class="mx-auto" :class="phaseMeta.panelClass" min-height="200" prepend-icon="mdi-account-group">
                            <template v-slot:title>Grupos</template>
                            <v-card-text>
                                <v-data-table v-model:sort-by="sortByName" class="table elevation-2" hover
                                items-per-page-text="Itens por página" page-text="{0}-{1} de {2}"
                                :headers="headersGroups" :items="listGroups" :loading="loadingGroups">
                                    <template v-slot:no-data>
                                        <v-alert class="my-4" :value="true">
                                            <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                                        </v-alert>
                                    </template>
                                    <template v-slot:item.id="{ item }">
                                        <v-icon icon="mdi-delete" class="ma-2 pa-2" color="error" size="small" @click="deleteGroup(provaId, item.columns.id)" />
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                        <!--#################################################################################################################################-->    

                        <!--####################################### RESPOSTAS PROVA EM GRUPO ################################################################-->
                        <v-card v-else-if="statusProva === '4'" class="mx-auto" :class="phaseMeta.panelClass" min-height="200" prepend-icon="mdi-note-text">
                            <template v-slot:title>Respostas da Atividade Avaliativa em Equipe</template>
                            <v-card-text>
                                <v-data-table :key="groupTableKey" class="table elevation-2" hover
                                items-per-page-text="Itens por página" page-text="{0}-{1} de {2}"
                                :headers="headersGroupsTest" :items="listGroupsTest" :loading="loadingGroupsTest">
                                    <template v-slot:no-data>
                                        <v-alert class="my-4" :value="true">
                                            <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                                        </v-alert>
                                    </template>
                                    <template v-for="(, i) in nQuestoes" :key="i" v-slot:[`item.${gamb2(i)}`]="{ item }">
                                        <v-icon v-if="item.columns[gamb2(i)] === 'certo'" color="success" icon="mdi-check-circle" size="x-large" />
                                        <v-icon v-else-if="item.columns[gamb2(i)] === 'quase'" color="warning" icon="mdi-alert-circle" size="x-large" />
                                        <v-icon v-else-if="item.columns[gamb2(i)] === 'errado'" color="error" icon="mdi-alpha-x-circle" size="x-large" />
                                    </template>
                                </v-data-table>
                            </v-card-text>
                            <v-card-actions class="ml-2">
                                Legenda:
                                <v-icon class="ml-2 mr-1" color="success" icon="mdi-check-circle" size="x-large" /> Acertou de Primeira
                                <v-icon class="ml-4 mr-1" color="warning" icon="mdi-alert-circle" size="x-large" /> Precisou de chance
                                <v-icon class="ml-4 mr-1" color="error" icon="mdi-alpha-x-circle" size="x-large" /> Não Pontuou
                            </v-card-actions>
                        </v-card>
                        <!--#################################################################################################################################-->

                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4">
                        <v-card class="mx-auto" min-height="200" prepend-icon="mdi-star">
                            <template v-slot:title>Nota Máxima</template>
                            <v-card-text class="text-center">
                                <v-progress-circular v-if="loadingNM" color="tertiary" indeterminate :size="80" />
                                <div v-else class="text-h1">{{ notaMaxima }}</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-card class="mx-auto" min-height="200" prepend-icon="mdi-percent-outline">
                            <template v-slot:title>Nota Individual</template>
                            <v-card-text class="text-center">
                                <v-progress-circular v-if="loadingNI" color="tertiary" indeterminate :size="80" />
                                <div v-else class="text-h1">{{ notaIndividual }}</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-card class="mx-auto" min-height="200" prepend-icon="mdi-percent-outline">
                            <template v-slot:title>Nota Equipe</template>
                            <v-card-text class="text-center">
                                <v-progress-circular v-if="loadingNE" color="tertiary" indeterminate :size="80" />
                                <div v-else class="text-h1">{{ notaEquipe }}</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>

            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-toolbar class="bg-primary-darken-1" elevation="1">
                        <v-spacer />
                        <v-icon color="warning" icon="mdi-alert" size="x-large" />
                        <v-spacer />
                    </v-toolbar>
                    <v-card-title class="text-center">{{ dialogMsg }}</v-card-title>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="red" variant="flat" @click="changeTestStatus(provaId, parseInt(statusProva2), 1)">Sim</v-btn>
                        <v-btn class="bg-primary" variant="flat" @click="closeDialog">Cancelar</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </template>
        <!--#################################################################################################################################################-->

    </template>

    <v-snackbar v-model="snackbar" :color="sbColor">
        {{ sbMessage }}
        <template v-slot:actions>
            <v-btn @click="snackbar = false">
                Fechar
            </v-btn>
        </template>
    </v-snackbar>

</template>

<style type="text/css">
.v-data-table.table .v-table__wrapper>table>thead>tr th,
.v-data-table.table .v-table__wrapper>table tbody>tr th {
    background-color: #16324A !important;
    color: white;
}

.v-data-table .v-table__wrapper>table>thead>tr>th.v-data-table__th--sortable:hover,
.v-data-table .v-table__wrapper>table tbody>tr>th.v-data-table__th--sortable:hover {
    color: white;
}

.status-card__value {
    font-size: clamp(1.15rem, 2vw, 2rem);
    font-weight: 700;
    line-height: 1.1;
    overflow-wrap: anywhere;
}

.status-card__subtitle {
    margin-top: 8px;
    opacity: 0.82;
}

.phase-summary-card,
.phase-panel--waiting,
.phase-panel--individual,
.phase-panel--grouping,
.phase-panel--team,
.phase-panel--done,
.phase-panel--stopped {
    border-top: 4px solid transparent;
}

.phase-panel--waiting {
    border-top-color: #3f8fc4;
}

.phase-panel--individual {
    border-top-color: #d58b1c;
}

.phase-panel--grouping {
    border-top-color: #4e6bb4;
}

.phase-panel--team {
    border-top-color: #2f8f62;
}

.phase-panel--done {
    border-top-color: #6b7280;
}

.phase-panel--stopped {
    border-top-color: #c2410c;
}

.activity-summary-bar {
    position: sticky;
    top: 16px;
    z-index: 3;
    border: 1px solid rgba(22, 50, 74, 0.08);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 10px 28px rgba(22, 50, 74, 0.08);
    backdrop-filter: blur(10px);
}

.activity-summary-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px;
    padding: 16px 18px;
}

.activity-summary-item {
    min-width: 0;
}

.activity-summary-item__label {
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #5f6f7d;
}

.activity-summary-item__value {
    margin-top: 4px;
    font-size: 1rem;
    font-weight: 700;
    color: #16324a;
    overflow-wrap: anywhere;
}
</style>

<script src="@/assets/js/prova.js" />
